import { Table, TableHead, TableRow, TableHeaderCell, TableCell } from './ui/Table'
import UiInput from './ui/Input'
import React from "react";
import { workerTypes } from "../constants";
import { contractorRateFieldKeys, contractorRateTypeLabels, normalizeContractorRates } from "../utils/workerRates";

const rowLabels = {
    weekdayMorningsRate: "Monday to Friday from 6am to 6pm",
    weekdayNightsRate: "Monday to Friday from 6pm to 6am",
    fridayNightRate: "Friday to Saturday from 6pm to 6am",
    saturdayDayRate: "Saturday from 6am to 6pm",
    saturdayNightRate: "Saturday to Sunday from 6pm to 6am",
    sundayDayRate: "Sunday from 6am to 6pm",
    sundayNightRate: "Sunday to Monday from 6pm to 6am",
};

export default function ContractorRatesTable({ rates, setRates, editing = false }) {
    const normalizedRates = normalizeContractorRates(rates);

    const disableScrollChange = (e) => e.target.blur();

    const updateRate = (field, type, value) => {
        const next = normalizeContractorRates(rates);
        next[field][type] = value;
        setRates(next);
    };

    return (
        <div className="overflow-x-auto">
            <Table emptyItems="rates" className="min-w-full border border-gray-300 text-sm">
                <TableHead className="bg-gray-100">
                    <TableRow>
                        <TableHeaderCell className="border border-gray-300 px-3 py-2 text-left">Scheduled Hours</TableHeaderCell>
                        {workerTypes.map(type => (
                            <TableHeaderCell key={type} className="border border-gray-300 px-3 py-2 text-center">
                                <div>{contractorRateTypeLabels[type] || type}</div>
                                <div style={{ fontSize: '12px', color: '#666' }}>Rate per hour (ex GST)</div>
                            </TableHeaderCell>
                        ))}
                    </TableRow>
                </TableHead>
                <tbody>
                    {contractorRateFieldKeys.map(field => (
                        <TableRow key={field}>
                            <TableCell className="border border-gray-300 px-3 py-2 font-medium">{rowLabels[field]}</TableCell>
                            {workerTypes.map(type => (
                                <TableCell key={`${field}-${type}`} className="border border-gray-300 px-2 py-1 text-center">
                                    <UiInput
                                        type="number"
                                        value={normalizedRates[field][type] ?? ""}
                                        onChange={(e) => updateRate(field, type, e.target.value)}
                                        onWheel={disableScrollChange}
                                        className={`w-24 border rounded p-1 text-center ${editing
                                            ? "bg-white focus:ring-2 focus:ring-blue-400"
                                            : "bg-gray-100 cursor-not-allowed"
                                            }`}
                                        disabled={!editing}
                                        placeholder="0"
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </tbody>
            </Table>
        </div>
    );
}
